import { render, staticRenderFns } from "./KETPsaDetails.vue?vue&type=template&id=147ba1eb&"
import script from "./KETPsaDetails.vue?vue&type=script&lang=js&"
export * from "./KETPsaDetails.vue?vue&type=script&lang=js&"
import style0 from "./KETPsaDetails.vue?vue&type=style&index=0&id=147ba1eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports